import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { SettingsRootParamList } from "../../../../types";
import {
  Card,
  FlatActionList,
  Page,
  Stack,
} from "@towersystems/roam-common-native";
import { useLinklyPosContext } from "../../../../utilities/linkly";
import { useMutation } from "@apollo/client";
import { Success } from "@towersystems/roam-common/lib/generated-types";
import React from "react";
import { MUTATION_REMOVE_PINPAD } from "../../common/constants";

export type LinklyPinpadSettingsListScreenProps = NativeStackScreenProps<
  SettingsRootParamList,
  "LinklyPinpadSettingsListScreen"
>;

export const LinklyPinpadSettingsListScreen = ({
  route,
  navigation,
}: LinklyPinpadSettingsListScreenProps) => {
  const [m] = useMutation<{
    removePinpad: Success;
  }>(MUTATION_REMOVE_PINPAD);

  const linklyContext = useLinklyPosContext();
  const { isActive, pinpadSecret, pinpadId } = route.params;

  const handleOnRemovePinpad = React.useCallback(
    async (pinpadId: string, clearPairSecret: boolean = false) => {
      return m({
        variables: {
          pinpadId,
        },
      })
        .then(() => {
          if (true === clearPairSecret) {
            linklyContext.methods.setPairSecret(undefined);
          }
          navigation.goBack();
        })
        .catch((err) => console.log(err));
    },
    []
  );

  return (
    <Page title="Pinpad Settings">
      <Stack vertical>
        <Card>
          <FlatActionList
            items={[
              isActive
                ? {
                    key: "deactivate",
                    title: "Forget Pinpad",
                    subTitle: "Forget this pinpad for use with this device",
                    onPress: () => {
                      linklyContext.methods.setPairSecret(undefined);
                      navigation.goBack();
                    },
                  }
                : {
                    key: "activate",
                    title: "Activate Pinpad",
                    subTitle: "Activate this pinpad for use with this device",
                    onPress: () => {
                      linklyContext.methods.setPairSecret(pinpadSecret);
                      navigation.goBack();
                    },
                  },
              {
                key: "pair",
                title: "Delete Pinpad",
                subTitle: "Delete this pinpad from the system",
                destructive: true,
                onPress: async () => {
                  await handleOnRemovePinpad(pinpadId, isActive);
                },
              },
            ]}
          />
        </Card>
      </Stack>
    </Page>
  );
};
